import { OperateReport } from '../reportError';
let report;
export function throwError(err, isPromise = true) {
    if (!isPromise) {
        throw err;
    }
    return Promise.reject(err);
}
export function logStart(isPromise = true, module, name, ignoreErrorReport) {
    if (!report) {
        report = new OperateReport('bridge');
    }
    const op = report.start({
        group: `${module}_${name}`,
    });
    const _fail = op.fail;
    op.fail = (err, ignore, params) => {
        _fail(err, ignoreErrorReport?.(err) ?? false, params);
        return throwError(err, isPromise);
    };
    return op;
}
